module.exports = __webpack_public_path__ + "img/fc2a4b4288958afb5c03bc374eef16a3.png";